/**
 * Stevi Pisoni Virgin Hair — chat widget.
 *
 * Vanilla JS, no dependencies, no build step.
 * THIS FILE CONTAINS NO API KEY AND NEVER WILL. It talks only to the Worker,
 * which holds the key server-side.
 *
 * Embed:
 *   <link rel="stylesheet" href="{{ 'chat-widget.css' | asset_url }}">
 *   <script defer src="{{ 'chat-widget.js' | asset_url }}"
 *           data-endpoint="https://stevipisoni-chat.workers.dev"
 *           data-turnstile-key=""></script>
 */
(function () {
  'use strict';

  var script = document.currentScript ||
    document.querySelector('script[src*="chat-widget"]');

  var CFG = {
    // Defaults to production. Local testing overrides it via data-endpoint,
    // so a forgotten attribute on the live theme can't silently break the chat.
    endpoint: (script && script.dataset.endpoint) ||
      'https://stevipisoni-chat.stevi-pisoni.workers.dev',
    turnstileKey: (script && script.dataset.turnstileKey) || '',
    greeting: 'Hi lovely, so glad you found me.\n\nAsk me anything about the hair — lengths, colours, what suits you, or how it all works.',
    maxChars: 500,
  };

  var history = [];
  var busy = false;
  var turnstileToken = null;

  // ─── Escape everything, then re-add only the formatting we control ──────
  function esc(s) {
    return String(s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  /** Safe subset: bare URLs → links, *word* → em. Runs AFTER escaping. */
  function fmt(text) {
    var out = esc(text);
    out = out.replace(
      /\b((?:https?:\/\/|www\.)[^\s<]+|stevipisoni\.com\/[^\s<)]+)/g,
      function (m) {
        var href = /^https?:\/\//.test(m) ? m : 'https://' + m.replace(/^www\./, 'www.');
        return '<a href="' + href + '" target="_blank" rel="noopener noreferrer">' + m + '</a>';
      }
    );
    out = out.replace(
      /(^|[\s(])\*([^*\n]{1,40})\*(?=[\s.,!?)]|$)/g,
      '$1<em>$2</em>'
    );
    out = out.replace(
      /\b([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})\b/g,
      '<a href="mailto:$1">$1</a>'
    );
    return out;
  }

  // ─── DOM ────────────────────────────────────────────────────────────────
  var root = document.createElement('div');
  root.className = 'spc-root';
  root.setAttribute('data-open', 'false');
  root.innerHTML =
    '<button class="spc-launcher" aria-label="Chat with Stevi Pisoni Virgin Hair">' +
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" ' +
      'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
      '<path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"/>' +
      '</svg></button>' +
    '<div class="spc-panel" role="dialog" aria-label="Chat with Stevi Pisoni Virgin Hair">' +
      '<div class="spc-head">' +
        '<div><p class="spc-title">Stevi Pisoni</p>' +
        '<p class="spc-sub">Virgin Hair</p></div>' +
        '<button class="spc-close" aria-label="Close chat">&times;</button>' +
      '</div>' +
      '<div class="spc-log" role="log" aria-live="polite"></div>' +
      '<div class="spc-foot">' +
        '<div class="spc-turnstile"></div>' +
        '<div class="spc-row">' +
          '<textarea class="spc-input" rows="1" maxlength="' + CFG.maxChars +
            '" placeholder="Ask me anything…" aria-label="Your message"></textarea>' +
          '<button class="spc-send">Send</button>' +
        '</div>' +
        '<p class="spc-note">Replies are automated. For an exact quote, Stevi will look after you personally.</p>' +
      '</div>' +
    '</div>';

  var launcher = root.querySelector('.spc-launcher');
  var closeBtn = root.querySelector('.spc-close');
  var log = root.querySelector('.spc-log');
  var input = root.querySelector('.spc-input');
  var send = root.querySelector('.spc-send');

  // ─── Rendering ──────────────────────────────────────────────────────────
  function bubble(role, text) {
    var el = document.createElement('div');
    el.className = 'spc-msg ' + (role === 'user' ? 'me' : 'bot');
    el.innerHTML = role === 'user' ? esc(text) : fmt(text);
    log.appendChild(el);
    log.scrollTop = log.scrollHeight;
    return el;
  }

  function typing() {
    var el = document.createElement('div');
    el.className = 'spc-msg bot';
    el.innerHTML = '<span class="spc-dots"><i></i><i></i><i></i></span>';
    log.appendChild(el);
    log.scrollTop = log.scrollHeight;
    return el;
  }

  function setBusy(state) {
    busy = state;
    send.disabled = state;
    input.disabled = state;
  }

  // ─── Turnstile (invisible; skipped when no key is configured) ───────────
  function getToken() {
    if (!CFG.turnstileKey) return Promise.resolve(null);
    if (turnstileToken) return Promise.resolve(turnstileToken);
    return new Promise(function (resolve) {
      // Cloudflare's script is loaded async, so a fast typist can reach here
      // before it exists. Wait for it rather than failing her customer.
      var done = false;
      var waited = 0;
      function finish(t) { if (!done) { done = true; resolve(t); } }
      setTimeout(function () { finish(null); }, 8000);   // never hang the send
      (function wait() {
        if (done) return;
        if (!window.turnstile) {
          if (waited >= 6000) return finish(null);
          waited += 100;
          return setTimeout(wait, 100);
        }
        try {
          window.turnstile.ready(function () {
          // MUST be an element that is actually in the document. Rendering into
          // a detached div silently never completes — if Cloudflare decides to
          // show a challenge it has nowhere to put it, and the visitor is
          // blocked for no reason they can see. This container lives inside the
          // chat panel: invisible mode shows nothing, and an interactive
          // challenge appears where the person can actually click it.
          window.turnstile.render(root.querySelector('.spc-turnstile'), {
            sitekey: CFG.turnstileKey,
            callback: function (t) { turnstileToken = t; finish(t); },
            'error-callback': function () { finish(null); },
            'expired-callback': function () { turnstileToken = null; },
          });
        });
        } catch (e) {
          // render() throws on a bad or mismatched sitekey. Thrown from inside
          // the Promise executor it REJECTS this promise, the caller's .catch
          // fires, and the message is never sent — the visitor sees an error
          // and the server never learns why. Never let the bot check swallow
          // a message: resolve null and let the Worker decide and log.
          finish(null);
        }
      })();
    });
  }

  function loadTurnstile() {
    if (!CFG.turnstileKey || window.turnstile) return;
    var s = document.createElement('script');
    s.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
    s.async = true; s.defer = true;
    document.head.appendChild(s);
  }

  // ─── Send ───────────────────────────────────────────────────────────────
  function submit() {
    var text = input.value.trim();
    if (!text || busy) return;

    bubble('user', text);
    history.push({ role: 'user', content: text });
    input.value = '';
    input.style.height = 'auto';
    setBusy(true);

    var dots = typing();
    var target = null;
    var acc = '';

    getToken()
      .then(function (token) {
        return fetch(CFG.endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            message: text,
            history: history.slice(0, -1),
            turnstileToken: token,
          }),
        });
      })
      .then(function (res) {
        if (!res.ok || !res.body) throw new Error('http_' + res.status);

        var reader = res.body.getReader();
        var dec = new TextDecoder();
        var buf = '';

        function pump() {
          return reader.read().then(function (r) {
            if (r.done) return;
            buf += dec.decode(r.value, { stream: true });
            var lines = buf.split('\n');
            buf = lines.pop() || '';

            var event = null;
            for (var i = 0; i < lines.length; i++) {
              var line = lines[i];
              if (line.indexOf('event: ') === 0) { event = line.slice(7).trim(); continue; }
              if (line.indexOf('data: ') !== 0) continue;

              var data;
              try { data = JSON.parse(line.slice(6)); } catch (e) { continue; }

              if (event === 'text' && data.text) {
                if (!target) { dots.remove(); target = bubble('assistant', ''); }
                acc += data.text;
                target.innerHTML = fmt(acc);
                log.scrollTop = log.scrollHeight;
              }
              // Worker blocked a hard-rule violation mid-stream: wipe and replace.
              if (event === 'replace' && data.text) {
                if (!target) { dots.remove(); target = bubble('assistant', ''); }
                acc = data.text;
                target.innerHTML = fmt(acc);
              }
            }
            return pump();
          });
        }
        return pump();
      })
      .then(function () {
        if (dots.parentNode) dots.remove();
        if (acc) history.push({ role: 'assistant', content: acc });
        setBusy(false);
        input.focus();
      })
      .catch(function () {
        if (dots.parentNode) dots.remove();
        if (!target) {
          bubble('assistant',
            "Something went wrong on my end. Email hello@stevipisoni.com and Stevi will help.");
        }
        setBusy(false);
      });
  }

  // ─── Events ─────────────────────────────────────────────────────────────
  launcher.addEventListener('click', function () {
    root.setAttribute('data-open', 'true');
    if (!log.children.length) bubble('assistant', CFG.greeting);
    loadTurnstile();
    setTimeout(function () { input.focus(); }, 60);
  });

  closeBtn.addEventListener('click', function () {
    root.setAttribute('data-open', 'false');
  });

  send.addEventListener('click', submit);

  input.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); submit(); }
  });

  input.addEventListener('input', function () {
    input.style.height = 'auto';
    input.style.height = Math.min(input.scrollHeight, 96) + 'px';
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && root.getAttribute('data-open') === 'true') {
      root.setAttribute('data-open', 'false');
    }
  });

  /**
   * Shopify's theme-preview bar is fixed to the bottom of the viewport and sits
   * on top of the launcher, which makes the widget look missing while testing.
   * Lift clear of it. The bar doesn't exist on a published theme, so this
   * self-cancels the moment the theme goes live — nothing to undo later.
   */
  function liftAbovePreviewBar() {
    if (document.getElementById('preview-bar-iframe')) root.style.bottom = '84px';
  }

  function mount() {
    document.body.appendChild(root);
    liftAbovePreviewBar();
    setTimeout(liftAbovePreviewBar, 1200);   // the bar is injected late
    setTimeout(liftAbovePreviewBar, 3000);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mount);
  } else {
    mount();
  }
})();
